export default "__VITE_ASSET__AHURrHZO__"